export default "__VITE_ASSET__DDk4WiMp__"